module.exports = __webpack_public_path__ + "img/18-3 RedteaGO App for iPhone eSIM.4941c297.png";